<template>
  <div>
    <div>
      <defNavBar title="Ares - Host profile" :info="infoItems" :home="true" />
    </div>
    <v-main>
      <v-container fluid class="pt-6">
        <div v-if="loading" class="spinner">
          <v-row>
            <v-col cols="12" span="12" align="center">
              <v-progress-circular :width="3" :size="25" color="green" indeterminate></v-progress-circular>
              <span class="markup ml-4">loading...</span>
            </v-col>
          </v-row>
        </div>
        <template v-else>
          <v-row align="center">
            <v-col cols="auto" v-if="showRaw">
              <v-select v-model="font" :items="fontChoices" label="Font" dense hide-details
                style="width: 170px;"></v-select>
            </v-col>
            <v-col cols="auto" v-if="showRaw">
              <v-btn small color="primary" @click="copyToClipboard">
                <v-icon left small>mdi-content-copy</v-icon>Copy to clipboard
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn small outlined color="primary" @click="showRaw = !showRaw">
                <v-icon left small>{{ showRaw ? 'mdi-view-dashboard-outline' : 'mdi-code-json' }}</v-icon>
                {{ showRaw ? 'Formatted view' : 'Raw JSON' }}
              </v-btn>
            </v-col>
          </v-row>

          <!-- Raw JSON (feeds the AI agent) -->
          <v-row v-if="showRaw">
            <v-col cols="12">
              <v-textarea v-model="profileText" :style="{ fontFamily: font }" class="profile-textarea" no-resize
                rows="1" outlined hide-details></v-textarea>
            </v-col>
          </v-row>

          <!-- Formatted view (text fields + tables) -->
          <v-row v-else>
            <v-col cols="12" class="formatted-view">
              <jsonView :data="profile" />
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import defNavBar from '@/components/ui/navbars/navbar.vue';
import jsonView from '@/components/eign/jsonView.vue';

export default {
  components: {
    defNavBar,
    jsonView
  },
  props: ['eign_encrid'],
  data() {
    return {
      loading: true,
      showRaw: true,
      font: 'Courier New',
      fontChoices: ['Courier New', 'Lucida Console'],
      profile: {},
      profileText: ''
    };
  },
  computed: {
    // navbar is filled from profile.profile.queryParams; the full object is shown as text in the textarea
    infoItems() {
      const q = (this.profile.profile && this.profile.profile.queryParams) || {};
      return [
        { label: 'Host: ', value: q.eignCode },
        { label: 'Name: ', value: q.eignNaam },
        { label: 'Email: ', value: q.eignEmail }
      ];
    }
  },
  mounted() {
    this.getHostProfile();
  },
  methods: {
    getHostProfile() {
      this.loading = true;
      this.$axios
        .post("ares/json/ares/eign/getEignProfile.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHostProfile"
          },
          getHostProfile: {
            eign_encrid: this.eign_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            console.log('test', res)
            this.profile = res.data.getHostProfile;
            this.profileText = this.formatProfile(this.profile);
            document.title = "Host profile " + ((this.profile.profile && this.profile.profile.queryParams && this.profile.profile.queryParams.eignCode) || '');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // present the returned object as readable text in the textarea
    formatProfile(obj) {
      if (obj === null || typeof obj !== 'object') {
        return obj != null ? String(obj) : '';
      }
      return JSON.stringify(obj, null, 2);
    },
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.profileText || '');
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: "Copied to clipboard",
          color: "success",
        });
      } catch (err) {
        console.log(err.message);
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: "Could not copy to clipboard",
          color: "error",
        });
      }
    }
  }
};
</script>

<style scoped>
/* Fill the viewport below the navbar + controls row; scroll internally on overflow */
.profile-textarea >>> textarea {
  height: calc(100vh - 190px) !important;
  max-height: calc(100vh - 190px);
  overflow-y: auto;
}
/* Formatted view fills the same space and scrolls internally on overflow */
.formatted-view {
  max-height: calc(100vh - 190px);
  overflow-y: auto;
}
</style>
